export default __webpack_public_path__ + "static/media/logo-kimiya.d52e2fc6.svg";